import UploadSection from './sections/upload-section';
import ImportSection from './sections/import-section';
import SummarySection from './sections/summary-section';
import STATUS from './status';
const COLOR_PRIMARY = window.WE && window.WE.colors.weColorPrimary6 || '#2E8CF0';
const COLOR_READY = window.WE && window.WE.colors.weColorGray10 || '#262626';
const COLOR_GRAY = window.WE && window.WE.colors.weColorGray6 || '#BFBFBF';
export default {
  components: {
    UploadSection,
    ImportSection,
    SummarySection
  },
  props: {
    templateLink: String,
    uploadName: String,
    needConfirm: Boolean,
    plugins: Array,
    root: Object,
    accept: String
  },
  data: () => ({
    status: STATUS.INIT,
    result: null
  }),
  computed: {
    dotStyleUpload() {
      const color = COLOR_PRIMARY;
      return {
        color,
        borderColor: color
      };
    },

    dotStyleImport() {
      const color = this.status >= STATUS.IMPORTING ? COLOR_PRIMARY : COLOR_READY;
      return {
        color,
        borderColor: color
      };
    },

    dotStyleComplete() {
      let color = COLOR_GRAY;

      if (this.status === STATUS.IMPORT_SUCCESS) {
        color = COLOR_PRIMARY;
      } else if (this.status >= STATUS.IMPORTING) {
        color = COLOR_READY;
      }

      return {
        color,
        borderColor: color
      };
    }

  },
  methods: {
    doImport(res) {
      this.$refs.import.doImport(res);
    },

    handleImported(result) {
      this.result = result;
      this.$emit('success');
    },

    handleStatus(status) {
      this.status = status;
    },

    handleClose() {
      this.$emit('close');
    }

  }
};